import {RemoteGetHealthSpecialtyDescription} from 'data/usecases/private/booking-flow/health/remote-get-health-specialty-description';
import {GetHealthSpecialtyDescription} from 'domain/usecases/private/booking-flow/health/get-health-specialty-description';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthSpecialtyDescription = (): GetHealthSpecialtyDescription =>
	new RemoteGetHealthSpecialtyDescription(
		makeBFFApiUrl(BookingFlowEndPoints.healthSpecialtyDescription),
		makeAuthorizeHttpClientDecorator(),
	);
